import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Role } from '../../../models/Role';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    ValidationErrors,
    Validators,
} from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'app-add-account-modal',
    standalone: true,
    imports: [ReactiveFormsModule, TranslateModule],
    templateUrl: './add-account-modal.component.html',
    styleUrl: './add-account-modal.component.scss',
})
export class AddAccountModalComponent {
    role: Role;
    public createAccountForm!: FormGroup;
    Role = Role;

    constructor(
        private activeModale: NgbActiveModal,
        private fb: FormBuilder,
        private toaster: ToastrService,
        private authService: AuthService,
        private translationService: TranslationService
    ) {
        this.createAccountForm = this.fb.group({
            pseudo: ['', Validators.required],
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            password: ['', Validators.required],
            verifyPassword: [
                '',
                [Validators.required, this.matchPassword('password')],
            ],
        });
    }

    matchPassword(controlName: string) {
        return (control: AbstractControl): ValidationErrors | null => {
            const passwd = control.parent?.get(controlName);
            if (control.value !== passwd?.value) {
                return { match: true };
            } else {
                return null;
            }
        };
    }

    cancel() {
        this.activeModale.close({ message: 'cancel' });
    }

    async validate() {
        if (!this.createAccountForm.valid) {
            return;
        }

        const pseudo = this.createAccountForm.value.pseudo;
        const passwd = this.createAccountForm.value.password;
        const firstname = this.createAccountForm.value.firstname;
        const lastname = this.createAccountForm.value.lastname;

        try {
            const affected = await firstValueFrom(
                this.authService.postAffectedUser(
                    this.role,
                    pseudo,
                    firstname,
                    lastname,
                    passwd
                )
            );

            this.toaster.success(
                this.translationService.instant(
                    'modales.addAccount.messages.success'
                )
            );
            this.activeModale.close({ message: 'created', pseudo: pseudo });
        } catch (error) {
            if ((error as HttpErrorResponse).status === 409) {
                this.toaster.error(
                    this.translationService.instant(
                        'modales.addAccount.messages.conflictError'
                    )
                );
            } else {
                this.toaster.error(
                    this.translationService.instant(
                        'modales.addAccount.messages.error'
                    )
                );
            }
        }
    }
}
